import styled from '@emotion/styled';

export const FormsContainer = styled.div`
    /* @media screen and (max-width: 824px) { */
    width: 100%;
    /* } */
`;
